import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    color: ${color.interface.lightGray};
    font-size: 1.1rem;
    text-align: center;
  }
`;
